import { jsx as _jsx } from "react/jsx-runtime";
import TextField from '@mui/material/TextField';
import { Field, useField } from 'formik';
const SelectField = ({ name, label, type, required, disabled, onChangeOverride, step = 1, sx, children, value, }) => {
    const [field, meta] = useField(name);
    const error = meta.touched && !!meta.error;
    const errorMessage = error ? meta.error : undefined;
    return (_jsx(Field, { component: TextField, select: true, sx: { width: '90%', ...sx }, error: error, name: field.name, value: value, onChange: onChangeOverride === null || onChangeOverride === undefined
            ? field.onChange
            : onChangeOverride, onBlur: field.onBlur, type: type, label: label, helperText: errorMessage, required: required, disabled: disabled, InputLabelProps: {
            shrink: true,
        }, variant: "outlined", inputProps: {
            step: type === 'number' ? step : undefined,
        }, children: children }));
};
export { SelectField };
